import { render, staticRenderFns } from "./ErrorNotFound.vue?vue&type=template&id=634a81aa&"
var script = {}
import style0 from "./ErrorNotFound.vue?vue&type=style&index=0&id=634a81aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports